import { Observable } from "rxjs";
import { ApiResponse } from "./types.domain";

export type SendForgotPasswordFn = (data: {
  Email: string,
}) => Observable<ApiResponse>;
